import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { PrimeNGConfig } from 'primeng/api';
import { WebSocketService } from './services/web-socket.service';
import { CalendarUtil } from './utils/calendar.util';
import { MessageUtil } from './utils/message.util';
import {LanguageEasyService} from "./services/language-easy.service";
import { GtagService } from './services/gtag.service';
import { AppUpdateService } from './services/app-update.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  constructor(
    translateService: TranslateService,
    private config: PrimeNGConfig,
    private messageUtil: MessageUtil,
    private webSocketService: WebSocketService, 
    private languageEasyService: LanguageEasyService,
    private gtagService: GtagService,
    private appUpdateService: AppUpdateService,
  ) {
    translateService.setDefaultLang('pt-br');
    translateService.use(languageEasyService.getLanguage());
    webSocketService.initializeWebSocketConnection();
  }

  async ngOnInit(): Promise<void> {
    this.gtagService.init();
    this.appUpdateService.init();
    this.config.setTranslation(await (new CalendarUtil(this.messageUtil)).getLocaleOptions());
  }
}
